module.exports = __webpack_public_path__ + "static/media/crown.9223ee0e.png";